// extracted by mini-css-extract-plugin
export var tocpicsGobackBtn = "bv_dP";
export var topicsFilterContainer = "bv_dM";
export var topicsFilterWrapper = "bv_dN";